import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getIntegrationsState = (state: GlobalState) => state[KEY];

const selectIntegrations = createSelector(getIntegrationsState, (integrations) => integrations.integrations);

const selectPending = createSelector(getIntegrationsState, (integrations) => integrations.action.pending);

const selectAction = createSelector(getIntegrationsState, (state) => state.action);

const selectError = createSelector(getIntegrationsState, (integrations) => integrations.action.error);

export const selectors = {
  selectIntegrations,
  selectPending,
  selectAction,
  selectError
};
